import { FOLDERS } from '../constants';
import { PatientUserFolder } from 'data/patient-management/types';

const rearrangeFolders = (folders: PatientUserFolder[]): PatientUserFolder[] => {
  const priorityFolders = [
    FOLDERS.ID_CARD,
    FOLDERS.INSURANCE_CARD,
    FOLDERS.PT_DEMOGRAPHICS,
    FOLDERS.PRESCRIPTIONS,
    FOLDERS.FEEDBACKS
  ];

  const result: PatientUserFolder[] = [];
  const addedFolderNames = new Set<string>();

  // Add priority folders first, in order
  priorityFolders.forEach((priorityName) => {
    const folder = folders.find((f) => f.folderName === priorityName);
    if (folder) {
      result.push(folder);
      addedFolderNames.add(priorityName);
    }
  });

  // Append remaining folders as-is (no sorting)
  folders.forEach((folder) => {
    if (!addedFolderNames.has(folder.folderName as string)) {
      result.push(folder);
    }
  });

  return result;
};

export { rearrangeFolders };
